<h2>{{formLabels['title']}} {{form1.value.name}}</h2>
<form [formGroup]="form1">
	<p-toast [style]="{marginTop: '80px'}"></p-toast>
	<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
	<mat-tab-group>
		<mat-tab label="Advertised Rates">
			<app-occupancy-summary></app-occupancy-summary>
		</mat-tab>
		<mat-tab label="LOS Rates">
			<app-rate-los></app-rate-los>
		</mat-tab>
		<mat-tab label="Rack Rates">
			<app-rate-bucket-detail></app-rate-bucket-detail>
		</mat-tab>
		<mat-tab label="Bulk Edit">
			<app-rate-bulk-edit></app-rate-bulk-edit>
		</mat-tab>
		<mat-tab label="Rate Summary">
			<app-rate-summary></app-rate-summary>
		</mat-tab>
	</mat-tab-group>
</form>
